export default "__VITE_ASSET__B3L8uP2R__"